module.exports = __webpack_public_path__ + "img/d.5bf674d8.jpg";